module.exports = __webpack_public_path__ + "img/logo-one.04cda68f.svg";